import { render, staticRenderFns } from "./AddToCartModal.vue?vue&type=template&id=64032aec&"
import script from "./AddToCartModal.vue?vue&type=script&lang=js&"
export * from "./AddToCartModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports